var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 28,
    viewBox: "0 0 46 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-mastercard"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9021 25.0067H29.0977V2.99338H16.9021V25.0067Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6765 14.0001C17.6765 9.53408 19.7582 5.55654 22.9999 2.99338C20.629 1.11856 17.6378 0.000116666 14.3864 0.000116666C6.68921 0.000116666 0.449707 6.2682 0.449707 14.0001C0.449707 21.7319 6.68921 28 14.3864 28C17.6378 28 20.629 26.8816 22.9999 25.0067C19.7582 22.4432 17.6765 18.466 17.6765 14.0001Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1151 22.6752V22.132H44.9738L44.8116 22.5057L44.649 22.132H44.5077V22.6752H44.6072V22.2654L44.7597 22.6188H44.8631L45.0156 22.2646V22.6752H45.1151ZM44.2204 22.6752V22.2245H44.4016V22.1327H43.9409V22.2245H44.1217V22.6752H44.2204ZM45.5503 13.9999C45.5503 21.7318 39.3104 27.9999 31.6136 27.9999C28.3622 27.9999 25.3705 26.8816 22.9999 25.0067C26.2416 22.4436 28.3235 18.4659 28.3235 13.9999C28.3235 9.53435 26.2416 5.55693 22.9999 2.99338C25.3705 1.11856 28.3622 0 31.6136 0C39.3104 0 45.5503 6.26809 45.5503 13.9999Z",
    fill: "#F79E1B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.87a0a87ff0ec118e8bb226f6bfec3215.svg";
export { ForwardRef as ReactComponent };